import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-body-content" }
const _hoisted_2 = { class: "confirmation-content" }
const _hoisted_3 = { class: "icon-wrapper" }
const _hoisted_4 = { class: "modal-footer-actions" }

import { ref } from "vue";
import { Icon } from "@iconify/vue";
import { Button, Modal } from "@/components/ui";
import ScheduleMeetingReminderModal from "@/components/meeting/ScheduleMeetingReminderModal.vue";

interface SelectedMeeting {
  id: string;
  title: string;
  duration: number;
  meetingDateTime: string;
  guestEmails?: string[];
  meetingURL?: string;
  contactId: string;
}

interface Props {
  selectedMeeting?: SelectedMeeting;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReminderFollowupModal',
  props: {
    selectedMeeting: {}
  },
  emits: ["closeReminderFollowupModal"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const showModal = ref(true);
const showScheduleMeetingReminderModal = ref(false);

const closeModal = () => {
  emit("closeReminderFollowupModal");
};

const confirm = () => {
  showScheduleMeetingReminderModal.value = true;
};

const closeScheduleMeetingReminderModal = () => {
  showScheduleMeetingReminderModal.value = false;
  closeModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      show: showModal.value && !showScheduleMeetingReminderModal.value,
      size: "sm",
      "blur-backdrop": false,
      zIndex: 10070,
      onClose: closeModal,
      "show-close-button": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Icon), {
                icon: "mdi:calendar-clock",
                class: "calendar-icon"
              })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-content" }, [
              _createElementVNode("h6", { class: "title" }, "Do you want to schedule a reminder follow-up?"),
              _createElementVNode("p", { class: "subtitle" }, " Set a quick reminder to schedule your important follow-up appointment. ")
            ], -1))
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Button), {
            variant: "secondary",
            onClick: closeModal
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("No", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            variant: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Confirm", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (showScheduleMeetingReminderModal.value)
      ? (_openBlock(), _createBlock(ScheduleMeetingReminderModal, {
          key: 0,
          "selected-meeting": __props.selectedMeeting,
          onCloseScheduleMeetingReminderModal: closeScheduleMeetingReminderModal
        }, null, 8, ["selected-meeting"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})